/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanPlanningClassEnum =
  (typeof RoutePlanPlanningClassEnum)[keyof typeof RoutePlanPlanningClassEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanPlanningClassEnum = {
  Auto: 0,
  Manual: 1,
} as const;
